import { render, staticRenderFns } from "./TransmittersStatusesOtpStock.vue?vue&type=template&id=90ce7528"
import script from "./TransmittersStatusesOtpStock.vue?vue&type=script&lang=js"
export * from "./TransmittersStatusesOtpStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports